import { User } from '../models/data'
import Urls from './url';
import { Storage } from '@capacitor/storage';

const authCode = process.env.REACT_APP_KEY;


class AuthServ {

    public user: User | null = null;

    public async getUser() {
        await this.setUser()
        return this.user
    }

    public async setUser() {
        const { value } = await Storage.get({ key: 'user' });
        if (value) {
            this.user = JSON.parse(value);
            await this.resetToken()
        }
        return this.user
    }

    public async unSetUser() {
        await Storage.remove({ key: 'user' });
        return
    }
    private async fetchUser(key: any) {
        const response = await fetch(`${Urls('signInUserUrl')}&swWprivateAuthCode=${authCode}`, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer' + key,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url

        }).then(resp => {
            return resp;
        })
        if (response.ok) {
            const message = await response.json();
            let userData = message.user.data;
            let userMetaData = message.meta;
            let newUser: User = {
                email: userData.user_email,
                username: userData.user_login,
                firstName: userMetaData.first_name,
                lastName: userMetaData.last_name,
                dateOfBirth: userMetaData?.date_of_birth,
                userLanguage: userMetaData?.user_language,
                isGiftCarduser: userMetaData?.giftcarduser,
                role: userMetaData?.role,
                token: key,
                id: userData.ID
            }
            await this.storeUser(newUser)

        } else {
            return {
                message: null,
                error: response.statusText
            }
        }
    }

    private async storeUser(user: User) {
        await Storage.set({
            key: 'user',
            value: JSON.stringify(user),
        });
        return
    }

    public async authenticateUser(data: any) {
        const body = {
            email: data.email,
            password: data.password,
            swWprivateAuthCode: authCode

        }

        const autResp = await fetch(Urls('authenticateUserUrl'), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header
        })
        if (autResp.ok) {
            const authMessage = await autResp.json();
            await this.fetchUser(authMessage.data.jwt);
            return {
                message: authMessage.data.jwt,
                error: authMessage.statusText
            }
        } else {
            return {
                message: null,
                error: autResp.json()
            }
        }
    }

    public async registerUser(data: any) {
        let meta_data = { date_of_birth: data.dateOfBirth, language: data.lan };
        const body = {
            email: data.email,
            password: data.password,
            first_name: data.firstname,
            user_meta: JSON.stringify(meta_data),
            last_name: data.lastname,
            locale: data.lan + '_CH',
            swWprivateAuthCode: authCode,

        };
        const response = await fetch(Urls('registerUser'), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header
        }).then(resp => {
            return resp;
        });
        if (response.ok) {
            const message = await response.json();
            return message;
        } else {
            return {
                message: null,
                error: response.statusText
            }
        }
    }

    public async resetToken() {
        let result
        let { value } = await Storage.get({ key: 'user' })
        let resp
        if (value) {
            let user = JSON.parse(value)
            let key = user.token;
            let body = {
                JWT: key,
                swWprivateAuthCode: authCode
            }

            resp = await fetch(Urls('resetTokenUrl'), {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    'Content-Type': 'application/json',
                    // 'Content-Type': 'application/x-www-form-urlencoded',s
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(body) // body data type must match "Content-Type" header

            });

            if (resp.ok) {
                let message = await resp.json();
                user.token = message.data.jwt;
                this.storeUser(user)
                result = true
            } else {
                //let message = await resp.json();
                await this.unSetUser().then(
                    () => {
                        this.user = null;
                        result = false
                    }
                )
            }
        }
        return result
    }

    public async requestPsChange(email: string, lan: string) {
        const body = {
            email: email,
            lan: lan
        };
        const response = await fetch(Urls('psRestCodeUrl'), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header
        })
        if (response.ok) {
            const message = await response.json();
            return message;
        } else {
            return {
                message: null,
                error: response.statusText
            }
        }
    }
    public async resetPs(data: any) {
        const body = {
            email: data.email,
            code: data.code,
            password: data.password,
        };
        const response = await fetch(Urls('resetPsUrl'), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header
        });
        if (response.ok) {
            let message = await response.json();
            return message;
        } else {
            return {
                message: null,
                error: response.statusText
            }
        }
    }

    public async fetchAUser(id: string) {

        let resp = await fetch(Urls('getUser', id), {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            // body data type must match "Content-Type" header
        })

        if (resp.ok) {
            let message = await resp.json();
            return {
                message: message,
                error: null
            }
        } else {
            return {
                message: null,
                error: resp.statusText
            }
        }
    }

    public async updateUser(info: any) {
        // where values is an object of meta data
       
        let result=null;
        let user: User;

        const { value } = await Storage.get({ key: 'user' });
        
        if (value) {
            user = JSON.parse(value);
            let resp = await fetch(`${Urls('updateUserUrl',user.id+'')}`, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    'Content-Type': 'application/json',
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer' + user.token,
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(info)
            })

            if (resp.ok) {
                await this.fetchUser(user.token).then(
                _=>{
                    result=true
                }
               );
   
            }
        }

        return result
    }

}

export default AuthServ